<template>
  <supplier-component :storeType="storeType"/>
</template>

<script>
import SupplierComponent from './SupplierComponent'

export default {
  components: {SupplierComponent},
  data () {
    return {
      storeType: 20
    }
  },
  created () {

  },
  methods: {}
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/supplier/supplier/index.vue